const ASSET_TYPE = {
    CHART: 'chart',
    TABLE: 'table',
    MAPSPICE: 'mapspice',
    CEB: 'ceb',
    CURRENCY: 'currency',
    SURVEY: 'survey',
    LAYOUT: 'layout',
};

const ASSET_TYPE_NAMES = {
    [ASSET_TYPE.CHART]: 'Charts',
    [ASSET_TYPE.TABLE]: 'Charts',
    [ASSET_TYPE.MAPSPICE]: 'Maps',
    [ASSET_TYPE.CEB]: 'Stories',
    [ASSET_TYPE.CURRENCY]: 'Stories',
    [ASSET_TYPE.SURVEY]: 'Surveys',
    [ASSET_TYPE.LAYOUT]: 'Templates',
};

export { ASSET_TYPE, ASSET_TYPE_NAMES }; 


// WEBPACK FOOTER //
// ./src/enums/AssetType.js